import { Form, FormItemProps, Input, Select } from "antd"
import { ReactNode } from "react"
import type { TextAreaProps, InputProps } from "antd/es/input"

const { Option } = Select
const { TextArea } = Input

export const CustomInput = ({
  label,
  name,
  required = false,
  onChange,
  ...restProps
}: InputItemProps) => {
  return (
    <Form.Item
      label={
        <span className="font-circular text-neutral300 text-sm  ">{label}</span>
      }
      name={name}
      rules={[{ required, message: "Please enter this field!" }]}
      // tooltip="This is a required field"
      {...restProps}
    >
      <Input onChange={onChange} />
    </Form.Item>
  )
}
export const CustomTextArea = ({
  label,
  name,
  required = false,
  inputProps,
  ...restProps
}: TextAreaInputItemProps) => {
  return (
    <Form.Item
      label={
        <span className="font-circular text-neutral300 text-sm  ">{label}</span>
      }
      name={name}
      rules={[{ required, message: "Please enter this field!" }]}
      // tooltip="This is a required field"
      {...restProps}
    >
      <Input.TextArea {...inputProps} />
    </Form.Item>
  )
}

export const CustomSelect = ({
  label,
  name,
  required = false,
  showSearch = true,
  placeholder,
  options,
  onChange,
  onSelectClick,
  isLoading = false,
  ...restProps
}: SelectItemProps) => {
  return (
    <Form.Item
      name={name}
      label={
        label ? (
          <span className="font-circular text-neutral300 text-sm  ">
            {label}
          </span>
        ) : (
          ""
        )
      }
      rules={[{ required, message: "Please enter this field!" }]}
      {...restProps}
    >
      <Select
        loading={isLoading}
        showSearch={showSearch}
        placeholder={placeholder}
        onChange={onChange}
        allowClear
        onClick={onSelectClick}
        filterOption={(input, option) => {
          if (option) {
            const value = (option.value as string) || ""
            return value.toLowerCase().indexOf(input.toLowerCase()) >= 0
          } else {
            return false
          }
        }}
        // open
      >
        {options?.map((option, index) => (
          <Option
            key={index}
            value={option.value}
          >
            {option.label}
          </Option>
        ))}
        {["first", "second"].map((item) => (
          <Option
            key={"empty" + item}
            disabled
            className="pointer-events-none"
          >
            {" "}
          </Option>
        ))}
      </Select>
    </Form.Item>
  )
}

type InputItemProps = FormItemProps & {
  label: React.ReactNode
  required?: boolean
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}
type TextAreaInputItemProps = FormItemProps & {
  label: React.ReactNode
  required?: boolean
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  inputProps?: TextAreaProps
}

type SelectItemProps = FormItemProps & {
  label: ReactNode
  required?: boolean
  showSearch?: boolean
  onChange?: (e: any) => void
  onSelectClick?: VoidFunction
  placeholder: string
  options: { label: string; value: string }[] | undefined
  isLoading?: boolean
}
